export default __webpack_public_path__ + "static/filters-f17fcc9ec0dca1168b75cf84242a4511.svg";